var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRescued(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rescued",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#fff8f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "love",
    transform: "translate(475.2 189.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_906",
    "data-name": "Group 906",
    transform: "translate(8.868 10.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9853",
    "data-name": "Path 9853",
    d: "M89.787,67.534l-3.412,2.145a.9.9,0,1,0,.959,1.526l3.412-2.146a1.8,1.8,0,1,1,1.919,3.052l-3.228,2.03a.9.9,0,1,0,.959,1.526l3.228-2.029a3.6,3.6,0,1,0-3.837-6.1Z",
    transform: "translate(-60.77 -50.645)",
    fill: "#d66b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9854",
    "data-name": "Path 9854",
    d: "M17.773,73.637,21,75.666a.9.9,0,1,0,.959-1.526l-3.228-2.03a1.8,1.8,0,1,1,1.918-3.052L24.063,71.2a.9.9,0,1,0,.959-1.526L21.61,67.533a3.6,3.6,0,1,0-3.837,6.1Z",
    transform: "translate(-16.086 -50.645)",
    fill: "#d66b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9855",
    "data-name": "Path 9855",
    d: "M56.931,29.63a3.984,3.984,0,1,0-3.984-3.984A3.984,3.984,0,0,0,56.931,29.63Zm0-6.166a2.182,2.182,0,1,1-2.182,2.182A2.182,2.182,0,0,1,56.931,23.464Z",
    transform: "translate(-39.661 -21.662)",
    fill: "#d66b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9856",
    "data-name": "Path 9856",
    d: "M46.59,51.389c.46.367.957.739,1.519,1.138l.094.066c2.121,1.5,3.284,2.254,4.447,2.254s2.322-.748,4.432-2.244l.108-.077c.518-.367,1.027-.748,1.514-1.131a.9.9,0,0,0,.279-1.039c-1.485-3.742-2.063-3.895-6.1-3.895h-.4c-4.1,0-4.684.152-6.172,3.893a.9.9,0,0,0,.275,1.036Zm2.748-2.841c.476-.286,1.49-.288,3.176-.286h.339c1.658,0,2.656,0,3.118.283.358.219.646.777,1.085,1.848q-.444.337-.9.663l-.108.076c-1.741,1.232-2.7,1.91-3.393,1.91s-1.656-.685-3.4-1.921l-.094-.066c-.324-.23-.625-.45-.909-.665C48.681,49.325,48.97,48.77,49.338,48.548Z",
    transform: "translate(-35.379 -37.522)",
    fill: "#d66b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907",
    transform: "translate(4.8 4.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9857",
    "data-name": "Path 9857",
    d: "M86.017,40.491a3.608,3.608,0,0,0-3.6,3.6v5.972a3.592,3.592,0,0,0-2.383.525l-3.287,2.066c-5.887,3.69-6.056,4-6.046,10.945v3.674c0,2.459.566,3.025,3.025,3.025H78.6c1.117,0,1.891-.041,2.437-.587s.588-1.32.587-2.448v-.236a5.329,5.329,0,0,1,.144-1.86,5.26,5.26,0,0,1,1.583-.978l.216-.111c1.965-1.013,6.056-3.121,6.056-8.395V44.1a3.609,3.609,0,0,0-3.6-3.6Zm1.8,15.2c0,3.853-2.621,5.526-5.077,6.792l-.216.111c-2.53,1.3-2.707,1.592-2.7,4.441v.246a6.3,6.3,0,0,1-.069,1.153A6.267,6.267,0,0,1,78.6,68.5H73.721a6.266,6.266,0,0,1-1.153-.069,6.266,6.266,0,0,1-.069-1.153V63.6c0-3.165-.007-4.754.583-5.822s1.936-1.913,4.618-3.593l3.289-2.068a1.791,1.791,0,0,1,1.868-.029.9.9,0,0,0,1.358-.777V44.1a1.8,1.8,0,1,1,3.6,0Z",
    transform: "translate(-46.944 -27.62)",
    fill: "#d66b00",
    stroke: "#d66b01",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9858",
    "data-name": "Path 9858",
    d: "M10.856,64.082l.216.111a5.277,5.277,0,0,1,1.583.978,5.3,5.3,0,0,1,.144,1.86v.247c0,2.459.566,3.025,3.025,3.025H20.7c2.459,0,3.025-.566,3.025-3.025V63.6c.011-6.948-.159-7.255-6.046-10.945l-3.287-2.066a3.588,3.588,0,0,0-3.741-.057.9.9,0,0,0,.913,1.554,1.79,1.79,0,0,1,1.868.029l3.289,2.068c2.682,1.681,4.028,2.523,4.618,3.593s.588,2.657.583,5.822v3.677a6.266,6.266,0,0,1-.069,1.153A6.266,6.266,0,0,1,20.7,68.5H15.822a6.267,6.267,0,0,1-1.153-.069,6.332,6.332,0,0,1-.069-1.164v-.235c0-2.849-.175-3.14-2.7-4.441l-.216-.111C9.224,61.214,6.6,59.54,6.6,55.688V44.1a1.8,1.8,0,1,1,3.6,0v3.543a.9.9,0,0,0,1.8,0V44.1a3.6,3.6,0,1,0-7.209,0V55.688c0,5.274,4.09,7.381,6.056,8.395Z",
    transform: "translate(-4.8 -27.62)",
    fill: "#d66b00",
    stroke: "#d66b01",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9859",
    "data-name": "Path 9859",
    d: "M33.848,24.735c.46.367.957.739,1.519,1.138l.094.066c2.121,1.5,3.284,2.254,4.447,2.254s2.322-.748,4.432-2.244l.108-.077c.518-.367,1.027-.748,1.514-1.131,5.463-4.313,8.159-9.321,7.4-13.74A7.178,7.178,0,0,0,41.072,6.983a6.076,6.076,0,0,1-1.157.933,5.806,5.806,0,0,1-1.177-.934,7.336,7.336,0,0,0-7.461-1.828A7.414,7.414,0,0,0,26.455,11c-.761,4.419,1.936,9.425,7.393,13.733ZM28.231,11.308a5.545,5.545,0,0,1,3.627-4.447,5.035,5.035,0,0,1,1.622-.269,5.976,5.976,0,0,1,4.037,1.715c2.037,1.877,2.751,1.877,4.78,0a5.381,5.381,0,0,1,9.29,3c.645,3.749-1.812,8.129-6.74,12.02-.461.364-.944.726-1.436,1.074l-.108.076c-1.741,1.232-2.7,1.91-3.393,1.91s-1.656-.685-3.4-1.921l-.094-.065c-.534-.378-1-.73-1.442-1.078-4.927-3.889-7.383-8.268-6.738-12.016Z",
    transform: "translate(-18.568 -4.784)",
    fill: "#d66b00",
    stroke: "#d66b01",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRescued);
export default __webpack_public_path__ + "static/media/Rescued.4a6123dab2f31895c3ef94fdec4a9174.svg";
export { ForwardRef as ReactComponent };